export const ContactMethod = {
  WHATSAPP: 'whatsapp',
  PHONE: 'phone',
} as const

export type ContactMethod = (typeof ContactMethod)[keyof typeof ContactMethod]
